var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-list-container",class:_vm.containerClass},[(_vm.$slots.header)?_c('div',{staticClass:"list-header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"list-content",style:(_vm.contentStyle)},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{staticClass:"list-footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }